/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { BooleanInputStrategy, DefaultInputStrategy, NumberInputStrategy, StringInputStrategy } from './LLMConfigurationFieldInputTypes';

// Misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { INPUT_BASE_TYPES } from '../../../../constants/llmConfiguration';

const FIELD_STRATEGIES = {
  [INPUT_BASE_TYPES.NUMBER]: NumberInputStrategy,
  [INPUT_BASE_TYPES.BOOLEAN]: BooleanInputStrategy,
  [INPUT_BASE_TYPES.STRING]: StringInputStrategy
};

// A simple renderer using strategy pattern to render the appropriate input fields
// Reference the RFC for all the available strategies and input types
const LLMFieldInput = ({ field, ...props }) => {
  const theme = useTheme();

  const StrategyComponent = FIELD_STRATEGIES[field.type] || DefaultInputStrategy;

  return <StrategyComponent field={field} props={props} theme={theme} />;
};

LLMFieldInput.propTypes = {
  field: PropTypes.shape({
    type: PropTypes.string,
    elementType: PropTypes.string,
    options: PropTypes.array,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    defaultValue: PropTypes.any
  }).isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  id: PropTypes.string
};

const MemoizedLLMFieldInput = React.memo(LLMFieldInput);

export default MemoizedLLMFieldInput;
